import React, { useEffect, useState } from 'react';
import { Form as FormikForm } from 'formik';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { useIsBreakpointSize } from 'app/shared/utils/useBreakpoint';
import { City } from 'app/shared/typings';
import { Box, Typography } from 'app/shared/components/atoms';
import { ActionButton, Textfield } from 'app/shared/components/molecules';
import { CitySelector } from 'app/shared/components/organisms';

interface FormProps {
  formikProps: any;
  useTwoColumnLayout?: boolean;
  fullWidthCta?: boolean;
  ctaText?: string;
  defaultCity?: City;
}
export const FormWithCitySelector: React.FC<
  React.PropsWithChildren<FormProps>
> = ({
  formikProps,
  useTwoColumnLayout = false,
  fullWidthCta,
  ctaText,
  defaultCity,
}) => {
  const intl = useIntl();
  const { isDesktop } = useIsBreakpointSize();
  const { colors } = useCurrentTheme();

  const [citySelectorValue, setCitySelectorValue] = useState<
    string | undefined
  >(defaultCity?.title || '');

  const { errors, isSubmitting, values, touched, setFieldValue } = formikProps;

  const textColor = colors.primary.white.base;

  useEffect(() => {
    if (defaultCity) {
      setCitySelectorValue(defaultCity.title);
    }
  }, [defaultCity]);

  return (
    <FormikForm>
      <Box
        flexDirection={useTwoColumnLayout && isDesktop ? 'row' : 'column'}
        gap={useTwoColumnLayout && isDesktop ? 16 : 8}
        data-qaid="newsletter-form-with-city"
      >
        <Box flexDirection="column" gap={4} flex={3}>
          <Box>
            <Typography
              fontSize="fontSize600"
              fontWeight="medium"
              fontFamily="title"
              color={textColor}
              lineHeight="100%"
            >
              {intl.formatMessage({ id: 'newsletter.stayConnected' })}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize="fontSize300" color={textColor}>
              {intl.formatMessage({ id: 'newsletter.beTheFirst' })}
            </Typography>
          </Box>
        </Box>
        <Box flexDirection="column" flex={2} gap={8}>
          <Box>
            <Textfield
              data-qaid="newsletter-form-with-city-email"
              hasError={touched.email && !!errors.email}
              helperText={touched.email ? errors.email : undefined}
              label={intl.formatMessage({ id: 'form.fields.email' })}
              labelColor={textColor}
              onChange={(event: any) =>
                setFieldValue('email', event.target.value)
              }
              value={values.email}
              // @ts-ignore
              type="email"
              autoCapitalize="off"
            />
          </Box>
          <Box>
            <CitySelector
              data-qaid="newsletter-form-city-selector"
              errors={touched.city ? errors.city : undefined}
              trackingKey="Newsletter"
              searchString={citySelectorValue}
              setSearchString={setCitySelectorValue}
              disableClosestCities={true}
              disableTopCities={true}
              labelColor={textColor}
              onChange={(city?: City) => {
                setFieldValue('city', city);
              }}
            />
          </Box>
          <ActionButton
            variant="primary"
            isLoading={isSubmitting}
            type="submit"
            data-qaid="newsletter-form-with-city-submit"
            fullWidth={fullWidthCta}
          >
            {ctaText || intl.formatMessage({ id: 'shared.signUp' })}
          </ActionButton>
        </Box>
      </Box>
    </FormikForm>
  );
};
